export default __webpack_public_path__ + "static/media/avatar-personnel.edb45905.svg";